import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 256 256",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" id=\"icon-plus\"><path d=\"M244.472 118.022h-106.78V11.242c0-5.432-4.404-9.835-9.835-9.835-5.432 0-9.835 4.403-9.835 9.835v106.78H11.242c-5.432 0-9.835 4.403-9.835 9.835s4.403 9.835 9.835 9.835h106.78v106.78c0 5.431 4.403 9.835 9.835 9.835 5.431 0 9.835-4.404 9.835-9.835v-106.78h106.78c5.431 0 9.835-4.404 9.835-9.835s-4.404-9.835-9.835-9.835z\" stroke-width=\"1\" stroke-miterlimit=\"10\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol